export interface FormsResetUploadActionType {
  type: '@forms/RESET_UPLOAD';
}

export const resetUpload = (): FormsResetUploadActionType => ({
  type: '@forms/RESET_UPLOAD',
});
